import React from 'react';
import { TRUNCATED_TEXT_TOOLTIP_DELAY_MS } from '@tanium/coreui-utils';
import styled from '@tanium/react-emotion';
import { SimpleTooltip } from '@tanium/react-tooltip';
import { useIsOverflowing } from '@tanium/react-use-is-overflowing';

const TruncatedText = styled('div')({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
});

export const ColumnHeaderLabel = ({ label }: { label?: React.ReactNode }) => {
  const [isOverflowing, overflowRef] = useIsOverflowing({
    dimension: 'width',
    updateOnResize: true,
  });

  return (
    <SimpleTooltip
      delayShowMs={TRUNCATED_TEXT_TOOLTIP_DELAY_MS}
      placement="top"
      content={isOverflowing && label}
    >
      {({ ref }) => (
        <TruncatedText ref={overflowRef}>
          <span ref={ref}>{label}</span>
        </TruncatedText>
      )}
    </SimpleTooltip>
  );
};
